import React from 'react';
import { Alert, Badge, ButtonGroup, Card } from 'react-bootstrap';
import Button from '../../components/Button';

function Cards() {
  return (<div className="styles-section row" id="cards">
    <div className='main-page-title col-sm-12'>
      <h3>Cards</h3>
    </div>

    <div className='home-page-content col-sm-12'>
      <div className="row align-items-start">

        <div className="col-sm-12 col-md-6">
          <Card className="mt-2">
            <Card.Header>
              <h5 className="card-header-title">
                Card header
              </h5>
            </Card.Header>
            <Card.Body>
              <Card.Title as='h6'>
                Card title
              </Card.Title>
              <Card.Text>
                Some quick example text to build on the card title and make up the bulk of the card's content.
              </Card.Text>
            </Card.Body>
            <Card.Footer>
              <Button variant="tertiary" href="#">
                Button
                <i className="fal fa-arrow-right icon-right"></i>
              </Button>
            </Card.Footer>
          </Card>
        </div>

        <div className="col-sm-12 col-md-6">
          <Card className="mt-2">
            <Card.Header>
              <Badge variant="warning">
                status
              </Badge>
              <h5 className="card-header-title">
                Card header
              </h5>
            </Card.Header>
            <Card.Body>
              <Card.Title as='h6'>Card title</Card.Title>
              <Card.Text>Some quick example text to build on the card title and make up the bulk of the card's content.</Card.Text>
            </Card.Body>
            <Card.Footer>
              <ButtonGroup>
                <Button variant="secondary" href="#">Cancel</Button>
                <Button variant="primary" href="#">Apply</Button>
              </ButtonGroup>
            </Card.Footer>
          </Card>
        </div>

        <div className="col-sm-12 col-md-6">
          <Card className="mt-2">
            <Card.Header>
              <Alert variant="danger">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.
              </Alert>
              <div>eyebrown</div>
              <h5 className="card-header-title">
                This is a header
              </h5>
            </Card.Header>
            <Card.Body>
              <Card.Text>Some quick example text to build on the card title and make up the bulk of the card's content.</Card.Text>
            </Card.Body>
            <Card.Footer>
              <Button variant="tertiary" href="#">
                Button
                <i className="fal fa-arrow-right icon-right"></i>
              </Button>
            </Card.Footer>
          </Card>
        </div>

        <div className="col-sm-12 col-md-6">
          <Card className="empty mt-2">
            There is not content here.
          </Card>
        </div>
      </div>
    </div>
  </div>);
}

export default Cards;